import { getEnsureLoadedLoader } from './loaderHelper';

export const useHeatplanLoader = (AddLoader: (loader: () => Promise<void>, key: string, icon?: string) => void) => {
    AddLoader(getEnsureLoadedLoader('HeatPlan'), 'heatplan.loading', '');
};
